module.exports = __webpack_public_path__ + "img/eastman-logo.0f455e8b.jpg";